import { render, staticRenderFns } from "./AccountProfileBoxViewAll.vue?vue&type=template&id=2c82d696&"
import script from "./AccountProfileBoxViewAll.vue?vue&type=script&lang=js&"
export * from "./AccountProfileBoxViewAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports